<template>
    <div
        :class="$widgetUI=='OLD-UI'?'bg-white shadow-md border-b px-2 py-4 lg:p-4 2xl:px-8 lg:sticky z-10':'px-2 py-4 lg:p-4 2xl:px-8 z-10 bg-white'"
        data-box-lead
        :style="additionalStyle">
        <div class="lg:flex justify-between items-center mr-1">
            <div class="w-full mb-2 lg:mb-0">
                <div class="flex items-center justify-between ">
                    <div
                        class="text-[16px] lg:text-[24px] xl:text-[28px] 2xl:text-[34px] leading-none flex items-center flex-wrap">
                        <span class="lg:font-semibold font-poppins leading-none px-1">
                            {{ countLead | formatNumber("1,000") }}
                        </span>
                        <span class="font-poppins font-light leading-none flex">Leads Available</span>


                        <span class="mx-3 flex items-baseline" v-if="$widgetUI=='NEW-UI'">
                            <span class="text-[14px] my-2  px-2 py-1 hidden lg:flex rounded-lg">
                                {{ selectedDataType.audience.title }}
                            </span>
                           <help-tip
                               v-if="selectedDataType.audience.title =='People'"
                               content='The "People" database will allow you to target your audience at home. Switch to "Businesses" to target people where they work.'
                               class="ml-2"
                           />
                           <help-tip v-else
                                     content='The "Businesses" database will allow you to target people where they work. Switch to "People" to target your audience at home.'
                                     class="ml-2"
                           />
                         </span>
                    </div>
                    <div v-if="$widgetUI=='NEW-UI'" class="flex gap-2">
                        <button v-if="mobileTabActive|| tabletActive" type="button"
                                class="group btn bg-fully border-1 bg-white flex lg:hidden lg:mx-2 w-[110px] items-center justify-between p-2"
                                @click="showFilter()"
                                data-title="Choose Filters" data-intro="Customize your list by applying filters to focus on what matters most." data-step="2"
                                data-position="bottom"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                 stroke="currentColor" class="size-3" width="16px">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                      d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"/>
                            </svg>
                            {{ filtersCount > 1 ? 'Filters' : 'Filter' }}

                            <span class="border-1 rounded-full bg-blue-900 text-white px-2"> {{ filtersCount }}</span>
                        </button>
                        <div class="fliter-action" v-if="mobileTabActive|| tabletActive"
                             data-title="Adjust quantity or budget" data-intro='Adjust your quantity or budget to match the list size that meets your needs.' data-step="5"
                             data-position="auto"
                             data-tooltip-class="quantity-btn"
                             data-highlight-class="quantity-btn"
                             data-scroll-to=".fliter-action"
                        >
                            <button v-if="$widgetUI=='NEW-UI'" type="button"
                                    class="group btn btn-orange bg-fully lg:hidden " @click="showAdjustquantity()"
                            >
                                Adjust quantity and buy list
                            </button>
                            <div class="my-2 md:hidden" v-if="$widgetUI=='NEW-UI'">
                                <save-list v-if="saveListOn"/>
                            </div>
                        </div>


                    </div>

                </div>
            </div>
            <div class="lg:flex flex-none items-center" v-if="$widgetUI=='OLD-UI'">
                <div class="xl:flex relative"
                     v-if="countLead && countLead >= minCount">
                    <template v-if="credit.chunk > 0">
                        <div class="mr-3">
                            <v-radio v-model="methodPay"
                                     value="not_split"
                                     class="text-[16px] lg:text-[12px] xl:text-[16px]">
                                <strong>{{ price | formatNumber("1,000.00", "$") }} or</strong>
                            </v-radio>
                        </div>
                        <div class="mr-3">
                            <v-radio v-model="methodPay"
                                     value="split"
                                     class="text-[16px] lg:text-[12px] xl:text-[16px]">
                                <strong>
                                    {{ credit.chunk }} payments of
                                    {{ credit.amount | formatNumber("1,000.00", "$") }}
                                </strong>
                            </v-radio>
                        </div>
                    </template>
                    <div class="flex" v-else>
                        <div
                            class="flex items-center justify-between w-full lg:w-[150px] 2xl:w-[170px] lg:mr-3 flex-shrink-0 mt-2 lg:mt-0 input-icon"
                            v-if="monetaryBudget">
                            <span class="text-[20px] lg:text-[24px] font-poppins">$</span>
                            <input
                                type="text"
                                id="lead-budget"
                                class="form-control disabled:cursor-not-allowed text-[20px] lg:text-[24px] font-poppins"
                                :class="$widgetUI=='NEW-UI'? '' : 'ml-1'"
                                v-model="price"
                                @keypress="isNumber"
                                @keydown="$event.keyCode === 38 || $event.keyCode === 40 ? $event.preventDefault() : false"
                            />
                        </div>
                        <span class="mr-3 text-[20px] lg:text-[24px] font-poppins font-semibold" v-else>
                            {{ price | formatNumber("1,000.00", "$") }}
                        </span>
                    </div>

                </div>

                <button
                    class="btn btn-orange bg-fully w-full mt-2 lg:mt-0 lg:w-[150px] 2xl:w-[170px] h-[46px] uppercase relative"
                    @click="addToCart"
                    :disabled="disabledBuyButton">
                    Buy this list
                </button>
            </div>
        </div>

        <div class="lg:flex justify-between items-center mt-3" v-if="$widgetUI=='OLD-UI'">
            <div class="w-full lg:w-[calc(100%-300px)] 2xl:w-[calc(100%-320px)] xl:flex items-center">
                <div
                    class="xl:text-[16px] 2xl:text-[20px] leading-snug text-primary flex items-center mb-2 xl:mb-0 xl:mr-3 whitespace-nowrap flex-shrink-0">
                    <strong class="mr-2">Adjust Quantity / Budget</strong>
                    <help-tip
                        content="You can adjust your lead quantity or budget by using the slide, or simply enter 'lead quantity' in the box at the end of the slider"/>
                </div>

                <no-ui-slider v-model="sliderModel"
                              :max="maxCount"
                              :disabled="sliderDisabled"/>
            </div>

            <div v-if="$widgetUI=='OLD-UI'"
                 class="lg:flex items-center justify-between w-full lg:w-[300px] 2xl:w-[350px] lg:ml-3 flex-shrink-0 mt-3 lg:mt-0">
                <label class="text-[12px] block leading-snug text-gray-400 mr-3" for="lead-quantity">
                    <strong v-if="countLead && countLead >= minCount">
                        Enter lead quantity you want
                        {{ minCount | formatNumber("1,000") }} -
                        {{ maxCount | formatNumber("1,000") }}
                    </strong>
                    <strong v-else>
                        Not enough leads to purchase
                    </strong>
                </label>

                <div class="form-group mb-0 w-full mt-2 lg:mt-0 lg:w-[150px] 2xl:w-[170px] flex-none"
                     v-if="$widgetUI=='OLD-UI'">
                    <input
                        type="text"
                        id="lead-quantity"
                        class="form-control disabled:cursor-not-allowed disabled:opacity-50"
                        :max="maxCount"
                        v-model="quantity"
                        ref="preQuantity"
                        @keypress="isNumber"
                        @keydown="$event.keyCode === 38 || $event.keyCode === 40 ? $event.preventDefault() : false"
                        :disabled="countLead < minCount"
                    />
                </div>
            </div>
        </div>

        <div v-if="countLead && countLead < minCount"
             class="flex items-center justify-center p-1 text-[12px]">
            <icon-warning class="mr-2"/>
            Our minimum order is {{ minCount }} leads. Please expand your geography or search
            criteria to increase your leads available.
        </div>

        <div v-else-if="countLead && countLead >= minCount && quantity < minCount"
             class="flex items-center justify-center p-1 text-[12px]">
            <icon-warning class="mr-2"/>
            You may not order fewer than {{ minCount }} leads.
        </div>
    </div>
</template>

<script>
import debounce from "lodash/debounce";
import {EventBus} from "@widget/plugins/event-bus";
import IconWarning from "@widget/components/icons/icon-warning";
import NoUiSlider from "@widget/components/ui/no-ui-slider";
import GlobalUtils from "@widget/utils/global";

export default {
    name: "box-leads",
    components: {
        NoUiSlider,
        IconWarning,
        SaveList: () => import("@widget/modules/saved-lists/save-list"),
    },
    data () {
        return {
            innerWidth: window.innerWidth,
            tabletActive:false,
            mobileTabActive:false,
            desktopTabActive:true,

        };
    },
    computed: {
        selectedDataType() {
            return this.$store.getters["widgetData/getSelectedDataForUI"];
        },
        saveListOn() {
            return this.$widgetConfig.save_list;
        },
        audiences() {
            return this.$store.getters["widgetData/getAudienceData"];
        },
        selectedData() {
            return this.$store.getters["widgetData/selectedData"];
        },
        selectsNotEmpty() {
            return this.selectedDataType.selects.length;
        },
        // subAudiencelength() {
        //     return this.selectedDataType.subAudience;
        // },
        geoNotEmpty () {
            return this.selectedData.selects.find(item => item.code.includes("_geo_search") || item.code.includes("_zip_radius") || item.code.includes("_mapping"));
        },
        filtersCount() {
            var countadd = 2;
            let data = this.selectedData.selects.find(item => item.code.includes("_geo_search") || item.code.includes("_zip_radius") || item.code.includes("_mapping"));
            if(data){
                countadd=1
            }
            return countadd + this.selectsNotEmpty;
        },
        countLead() {
            return this.$store.getters["calculateLeads/getCount"].total;
        },
        methodPay: {
            set(value) {
                this.$store.commit("calculateLeads/setCredit", {
                    key: "method",
                    value
                });
            },
            get() {
                return this.$store.getters["calculateLeads/getCredit"].method;
            }
        },
        quantity: {
            set: debounce(function (value) {
                if (Number(value) > this.maxCount) {
                    this.$store.commit("calculateLeads/setQuantity", this.maxCount);
                } else {
                    this.$store.commit("calculateLeads/setQuantity", Number(value));
                }
                this.$store.commit("widgetData/setUserChanged");

                this.getPrice();
            }, 1000),
            get() {
                return this.$store.getters["calculateLeads/getQuantity"];
            }
        },
        minCount() {
            return this.$store.getters["calculateLeads/getCount"].min;
        },
        maxCount() {
            return this.$store.getters["calculateLeads/getCount"].max;
        },
        loading() {
            return this.$store.getters["calculateLeads/getLoading"];
        },
        credit() {
            return this.$store.getters["calculateLeads/getCredit"];
        },
        price: {
            set: debounce(function (value) {
                this.$store.commit("calculateLeads/setPrice", Number(value));
                this.$store.commit("widgetData/setUserChanged");
                this.getQuantity();
            }, 2000),
            get() {
                return this.$store.getters["calculateLeads/getPrice"];
            }
        },
        sliderDisabled() {
            return this.maxCount < this.minCount;
        },
        disabledBuyButton() {
            return this.quantity < this.minCount || !this.userChanged;
        },
        additionalStyle() {
            let headerEl = document.getElementsByTagName("header")[0];
            if (headerEl) {
                return {top: `${headerEl.offsetHeight}px`};
            }
            return {top: 0};
        },
        sliderModel: {
            set: debounce(function (value) {
                this.$store.commit("calculateLeads/setQuantity", Number(value));
                this.$store.commit("widgetData/setUserChanged");

                this.getPrice();
            }, 300),
            get() {
                return this.$store.getters["calculateLeads/getQuantity"];
            }
        },
        userChanged() {
            return this.$store.getters["widgetData/getUserChanged"];
        },
        monetaryBudget() {
            return this.$store.getters["calculateLeads/getMonetaryBudget"];
        }
    },
    watch: {
        selectedData: {
            handler() {
                this.getCount();
            },
            deep: true
        }
    },
    methods: {
        showAdjustquantity() {
            this.$store.state.widgetData.showRightbar = true;
            this.$store.state.widgetData.showfilter = false;
        },
        showFilter() {
            this.$store.state.widgetData.showfilter = true;
        },

        isNumber(event) {
            return GlobalUtils.isNumber(event);
        },
        addToCart() {
            if (parseInt(this.quantity) >= this.minCount) {
                //window.splitTrack("register_buy_list");
                this.$modal.show("modal-cart");
            }
        },
        async getPrice() {
            this.$store.commit("others/setLoading", true);

            await this.$store.dispatch("calculateLeads/getPrice");

            this.$store.commit("others/setLoading", false);
        },
        async getQuantity() {
            this.$store.commit("others/setLoading", true);

            await this.$store.dispatch("calculateLeads/getQuantity");

            this.$store.commit("others/setLoading", false);
        },
        async getCount() {
            this.$store.commit("others/setLoading", true);

            await this.$store.dispatch("calculateLeads/getCount");

            await this.getPrice();
        },
        async getMonetaryBudget() {
            await this.$store.dispatch("calculateLeads/getMonetaryBudget");
        },
        getcheckDivec(){
            this.innerWidth = window.innerWidth;
            if(this.innerWidth  < 1024 && this.innerWidth  > 724 ){
                this.tabletActive=true;
                this.mobileTabActive=false;
                this.desktopTabActive=false;
            }
            else if (this.innerWidth < 724){
                this.tabletActive=false;
                this.mobileTabActive=true;
                this.desktopTabActive=false;
            }
            else{
                this.tabletActive=false;
                this.mobileTabActive=false;
                this.desktopTabActive=true;
            }
        }
    },
    created() {
        this.getMonetaryBudget();
        this.getCount();
        this.getcheckDivec();
        window.addEventListener('resize', () => {
            this.getcheckDivec();
        })
    },
    mounted() {
        EventBus.$on("focus-input-lead", () => {
            if (this.$refs.preQuantity) {
                this.$refs.preQuantity.focus();
            }
        });


    }
};
</script>
